import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import Person from '../../models/Person'
import User from '../../models/User'

export interface PersonListState extends PaginatedApiState {
  people?: (Person & User)[] 
}

const PersonList = (state: PersonListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<PersonListState>('PERSON_LIST')(state, action)
  }
}

export default PersonList
